import { jsx as _jsx } from "react/jsx-runtime";
import * as ReachAlertDialog from "@reach/alert-dialog";
import classNames from "classnames";
export const AlertModalTitle = (param)=>{
    let { className, ...restOfProps } = param;
    return /*#__PURE__*/ _jsx(ReachAlertDialog.AlertDialogLabel, {
        className: classNames("text-24 font-semibold text-grey-12", className),
        ...restOfProps
    });
};
